import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ArrowDownIcon } from 'lucide-react';
interface ExitProps {
  onOwnerContactOpen: () => void;
}
export function Exit({
  onOwnerContactOpen
}: ExitProps) {
  return <main className="bg-white min-h-screen" data-id="element-326">
      {/* SECTION 1: HERO */}
      <section className="relative min-h-screen flex flex-col items-center justify-center px-6 py-20 bg-white text-center" data-id="element-327">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-328">
          {/* Logo */}
          <img src="https://cdn.magicpatterns.com/uploads/vdgv36ytuJeDtCVoSnd1Nw/DF_logo_.png" alt="Deal Flow" className="h-16 md:h-20 mb-8" style={{
          filter: 'invert(1) hue-rotate(180deg)'
        }} data-id="element-329" />

          {/* Subheadline */}
          <p className="text-deal-green text-base md:text-lg lg:text-xl italic mb-4 md:mb-6 font-bold" data-id="element-330">
            If you're doing above $10M in annual revenue...
          </p>

          {/* Headline */}
          <h1 className="text-3xl md:text-6xl lg:text-7xl font-serif font-bold italic text-gray-900 leading-[1.1] mb-4 md:mb-8 tracking-tight" data-id="element-331">
            Get A Qualified Cash Buyer In 90 Days, Guaranteed
          </h1>

          {/* Body */}
          <p className="text-gray-500 text-sm md:text-lg lg:text-xl italic max-w-3xl leading-relaxed mb-6 md:mb-12" data-id="element-332">
            We'll{' '}
            <span className="font-bold text-gray-700" data-id="element-333">value your business</span>
            , guarantee a{' '}
            <span className="underline text-gray-700" data-id="element-334">sales price</span>, and
            connect you to a cash buyer from our network of{' '}
            <span className="font-bold text-gray-700" data-id="element-335">
              6,000+ PE funds and family offices
            </span>{' '}
            - privately, on your terms, with{' '}
            <span className="underline text-gray-700" data-id="element-336">no listings</span> or{' '}
            <span className="underline text-gray-700" data-id="element-337">broker fees</span>.
          </p>

          {/* Video */}
          <div className="w-full max-w-5xl mb-4 md:mb-6" style={{
          position: 'relative',
          paddingTop: '56.25%'
        }} data-id="element-338">
            <iframe src="https://iframe.mediadelivery.net/embed/460652/6819bdc9-155a-45e1-88ef-ebe556b475f0?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
            border: 0,
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '100%'
          }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen className="rounded-xl" data-id="element-339" />
          </div>

          {/* Arrows pointing down */}
          <div className="flex items-end justify-center gap-6 mb-6 text-deal-green" data-id="element-340">
            <motion.div animate={{
            y: [0, 8, 0]
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} style={{
            transform: 'rotate(-20deg)'
          }} data-id="element-341">
              <ArrowDownIcon className="w-8 h-8 md:w-10 md:h-10" strokeWidth={2.5} data-id="element-342" />
            </motion.div>
            <motion.div animate={{
            y: [0, 8, 0]
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.15
          }} data-id="element-343">
              <ArrowDownIcon className="w-10 h-10 md:w-12 md:h-12" strokeWidth={2.5} data-id="element-344" />
            </motion.div>
            <motion.div animate={{
            y: [0, 8, 0]
          }} transition={{
            duration: 1.2,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 0.3
          }} style={{
            transform: 'rotate(20deg)'
          }} data-id="element-345">
              <ArrowDownIcon className="w-8 h-8 md:w-10 md:h-10" strokeWidth={2.5} data-id="element-346" />
            </motion.div>
          </div>

          {/* CTA Button */}
          <motion.button onClick={onOwnerContactOpen} animate={{
          x: [0, -3, 3, -3, 3, 0]
        }} transition={{
          duration: 0.5,
          repeat: Infinity,
          repeatDelay: 2.5,
          ease: 'easeInOut'
        }} className="bg-deal-green text-white font-bold text-xl md:text-2xl px-14 md:px-20 py-7 md:py-8 rounded-xl hover:bg-deal-green-dark transition-colors duration-300 flex items-center gap-3 shadow-lg shadow-deal-green/25" data-id="element-347">
            Book Your Confidential Consultation
            <ArrowRightIcon className="w-7 h-7 md:w-8 md:h-8" data-id="element-348" />
          </motion.button>
        </motion.div>
      </section>
    </main>;
}